import Details from "components/Analytics/Details/Details";
import React, { useState } from "react";
import classes from "./AnalyticsPage.module.css";
import clsx from "clsx";
import FilteringSection from "components/Analytics/FilteringSection/FilteringSection";
import AiAnalysis from "components/Analytics/AiAnalysis/AiAnalysis";
import TradingChart from "components/Analytics/Chart/Chart";
import { Heading } from "components/common";
import axios from "axios";
const PERIODS = [
  { text: "1 Minute", multiplier: 1, timespan: "minute" },
  { text: "5 Minute", multiplier: 5, timespan: "minute" },
  { text: "15 Minute", multiplier: 15, timespan: "minute" },
  { text: "1 Hour", multiplier: 1, timespan: "hour" },
  // { text: "4 Hour", multiplier: 4, timespan: "hour" },
  // { text: "1 Day", multiplier: 1, timespan: "day" },
  // { text: "7 Days", multiplier: 1, timespan: "week" },
  // { text: "15 Days", multiplier: 15, timespan: "day" },
  // { text: "30 Days", multiplier: 1, timespan: "month" },
];
const AnalyticsPage = () => {
  const [contactAddress, setContactAddress] = useState("");
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("bsc"); // Ethereum
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(PERIODS[3]); // Default: 15m

  const [analysisData, setAnalysisData] = useState([]);

  const handleAnalyse = async () => {
    let data_api = process.env.REACT_APP_API + "/analyse-token";
    let body = {
      chain_id: 56,
      contract_address: contactAddress,
    };

    let {data, status} = await axios.post(data_api, body);
    if(status === 200){
      console.log(data);
    }

    let analysisResult = [];

  //   {
  //     "anti_whale_modifiable": "0",
  //     "buy_tax": "0",
  //     "can_take_back_ownership": "0",
  //     "cannot_buy": "0",
  //     "cannot_sell_all": "0",
  //     "creator_address": "0x970609ba2c160a1b491b90867681918bdc9773af",
  //     "creator_balance": "8135.389157646311854474",
  //     "creator_percent": "0.000002",
  //     "dex": [
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "17093671.844521066141818819667884",
  //             "pair": "0x4f31fa980a675570939b737ebdde0471a4be40eb"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "12685687.31806036",
  //             "pair": "0x16b9a82891338f9ba80e2d6970fdda79d1eb0dae"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "9993119.06934841380972596699",
  //             "pair": "0x36696169c63e42cd08ce11f5deebbcebae652050"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "7313798.37393091777871492386",
  //             "pair": "0x172fcd41e0913e95784454622d1c3724f546f849"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "4526408.38131967133502877511",
  //             "pair": "0x7f51c8aaa6b0599abd16674e2b17fec7a9f674a1"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "3671888.84505923143415508872",
  //             "pair": "0xfe4fe5b4575c036ac6d5cccfe13660020270e27a"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "3552965.231846232768177075163920",
  //             "pair": "0x92b7807bf19b7dddf89b706143896d05228f3121"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "1913020.03234790",
  //             "pair": "0x7efaef62fddcca950418312c6c91aef321375a00"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV1",
  //             "liquidity": "1613606.66749458",
  //             "pair": "0xc15fa3e22c912a276550f3e5fe3b0deb87b55acd"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "762725.620205946833586635101320",
  //             "pair": "0xbf72b6485e4b31601afe7b0a1210be2004d2b1d6"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "717513.76287354",
  //             "pair": "0xec6557348085aa57c72514d67070dc863c0a5a8c"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "668554.67050817782749753216",
  //             "pair": "0x47a90a2d92a8367a91efa1906bfc8c1e05bf10c4"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "520318.09434801635931103392",
  //             "pair": "0x7862d9b4be2156b15d54f41ee4ede2d5b0b455e4"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "494716.47162101",
  //             "pair": "0xa39af17ce4a8eb807e076805da1e2b8ea7d0755b"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "295467.250630519252915988604419",
  //             "pair": "0x4f3126d5de26413abdcf6948943fb9d0847d9818"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Biswap",
  //             "liquidity": "293511.31515331",
  //             "pair": "0x8840c6252e2e86e545defb6da98b2a0e26d8c1ba"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Biswap",
  //             "liquidity": "286829.20835308",
  //             "pair": "0xda8ceb724a06819c0a5cdb4304ea0cb27f8304cf"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "ThenaV3",
  //             "liquidity": "205432.86510196716130233528",
  //             "pair": "0xd405b976ac01023c9064024880999fc450a8668b"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "146560.84852360486320063096",
  //             "pair": "0x6fe9e9de56356f7edbfcbb29fab7cd69471a4869"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "mdex",
  //             "liquidity": "143420.25451764",
  //             "pair": "0x62c1dec1ff328dcdc157ae0068bb21af3967acd9"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Biswap",
  //             "liquidity": "122833.66435977",
  //             "pair": "0x1483767e665b3591677fd49f724bf7430c18bf83"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "119810.060762443986350416754937",
  //             "pair": "0x2c3c320d49019d4f9a92352e947c7e5acfe47d68"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "104744.242532337408091537513452",
  //             "pair": "0xc98f01bf2141e1140ef8f8cad99d4b021d10718f"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "102556.16717049",
  //             "pair": "0x703f1c0b4399a51704e798002281bf26d6f9c2e6"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV1",
  //             "liquidity": "93490.45804259",
  //             "pair": "0x20bcc3b8a0091ddac2d0bc30f68e6cbb97de59cd"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Ape",
  //             "liquidity": "87515.78379496",
  //             "pair": "0x2e707261d086687470b515b320478eb1c88d49bb"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "mdex",
  //             "liquidity": "39592.86188820",
  //             "pair": "0x9f4da89774570e27170873befd139a79cb1a3da2"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "mdex",
  //             "liquidity": "28913.28824616",
  //             "pair": "0x09cb618bf5ef305fadfd2c8fc0c26eecf8c6d5fd"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV1",
  //             "liquidity": "27170.84401367",
  //             "pair": "0x85f8628bfff75d08f1aa415e5c7e85d96bfd7f57"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "25438.0314368272915474914",
  //             "pair": "0x1401ff943d08a7e098328c1d3a9d388923b115d2"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "25039.471175178075",
  //             "pair": "0x4e26d812a134560ee81202f560b6965ab7feda89"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "20884.55906009",
  //             "pair": "0x6321b57b6fdc14924be480c54e93294617e672ab"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "19807.780889290423322793190524",
  //             "pair": "0x8b53b3e4602f86ed5dd1d7fb76733aac8f386acd"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "8120.710505485742301502182888",
  //             "pair": "0xccdfcd1aac447d5b29980f64b831c532a6a33726"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "7025.72656326197012225579",
  //             "pair": "0x6805e0e5333c5c3accf2930be4734e2b98f4ce06"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "6977.24426062768736886072",
  //             "pair": "0x8ec186cd1ad51c380bd23fde29f852226647616c"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "6352.44004859920636885620",
  //             "pair": "0x4d170f8714367c44787ae98259ce8adb72240067"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "6313.09862009",
  //             "pair": "0x618f9eb0e1a698409621f4f487b563529f003643"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "4756.614013334175",
  //             "pair": "0xb2e1f68f602de6da17c2956449a25660ac150333"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "3957.116214433519236171308201",
  //             "pair": "0x18fc1e95adb68b556212ebbad777f3fbb644db98"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "3802.10435766442665804000",
  //             "pair": "0x55fe55677e8398ef5c92f01b780403c9a771a1c0"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "ThenaV3",
  //             "liquidity": "2640.055145132692266201179895",
  //             "pair": "0x1b9a1120a17617d8ec4dc80b921a9a1c50caef7d"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "2046.19262150",
  //             "pair": "0x6be6a437a1172e6c220246ecb3a92a45af9f0cbc"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Ape",
  //             "liquidity": "1656.36643722",
  //             "pair": "0x83c5b5b309ee8e232fe9db217d394e262a71bcc0"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "1098.403138973539531903020720",
  //             "pair": "0x84e47c7f2fe86f6b5efbe14fee46b8bb871b2e05"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "412.183383652218645317209335",
  //             "pair": "0x6a32b830acac9ad59f23d77e0dc6c6d5e4622d31"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "340.157598220920586571465",
  //             "pair": "0xbfbba3de6a260c8374f8299c38898312c2d6e9a6"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV2",
  //             "liquidity": "200.12408361",
  //             "pair": "0x4e83ae65e9262712f4f4bc2f9dfe921704bc71df"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "157.72137667",
  //             "pair": "0xdc17b8899d8084e64913bd508bb13bfc2696debb"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "152.676687068720287043760",
  //             "pair": "0x1625f94b9185c028733e3eb41c8203b6b8a11729"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "129.9798895375696353138",
  //             "pair": "0xe04d921d6ab7c3ef2eee14dd7a95be5706a1ea93"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "PancakeV1",
  //             "liquidity": "101.99702933",
  //             "pair": "0x3f3d4ce222a7c919ea7f0231471c77478e36fc0d"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "50.82934263",
  //             "pair": "0xf048cf3eac3c17ad47ae1c4e37408040177a8554"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "29.644494496640052107970163",
  //             "pair": "0x5f69c87e3ed60d6b6b544c16f0072cd4a72ad13c"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "22.064646610279370692076792",
  //             "pair": "0xa25c5774bd3f5a3fcdebadf00bcfea50e93ee678"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "8.13117182640132444824",
  //             "pair": "0xc23a44f38634ced8ba6f71483bb5bd27012739f7"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "mdex",
  //             "liquidity": "3.77437318",
  //             "pair": "0x577e506d43d21d0e53c00cfb8eae2a98a2fa4179"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "ThenaV2",
  //             "liquidity": "2.46453486",
  //             "pair": "0x262029c946d868ca5c339d4ea605e65928e2013a"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Biswap",
  //             "liquidity": "1.48635882",
  //             "pair": "0x5032a2fb29b72ad8dacc71429a2a81df637433bb"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Ape",
  //             "liquidity": "0.24609910",
  //             "pair": "0xcd1e0b85b72ea3ecdf8a4b79c7bf9bcff5113829"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Ape",
  //             "liquidity": "0.23041006",
  //             "pair": "0xc32f6cf83c153729153f15bdfd5bbc9e9148947f"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "mdex",
  //             "liquidity": "0.22051561",
  //             "pair": "0x235c1f439cfd64e153dd77194afba685e3cc3de5"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "UniswapV3",
  //             "liquidity": "0.082868574445035814530405",
  //             "pair": "0x872d049c981044d6939de9e571f2175f823b65c4"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "0.010301328083140374039276",
  //             "pair": "0x418e8bf549cb4a544d033edc8bc26c3357e6efa7"
  //         },
  //         {
  //             "liquidity_type": "UniV3",
  //             "name": "PancakeV3",
  //             "liquidity": "0.001988667391571665340424",
  //             "pair": "0xb2d25f062a88db40861007b07e10549772272b0b"
  //         },
  //         {
  //             "liquidity_type": "UniV2",
  //             "name": "Biswap",
  //             "liquidity": "0.00000000",
  //             "pair": "0x66401653618414cfb44e027c754716a97884b3af"
  //         }
  //     ],
  //     "external_call": "0",
  //     "hidden_owner": "0",
  //     "holder_count": "0",
  //     "honeypot_with_same_creator": "0",
  //     "is_anti_whale": "0",
  //     "is_blacklisted": "0",
  //     "is_honeypot": "0",
  //     "is_in_dex": "1",
  //     "is_mintable": "1",
  //     "is_open_source": "1",
  //     "is_proxy": "0",
  //     "is_whitelisted": "0",
  //     "lp_holder_count": "10",
  //     "lp_holders": [
  //         {
  //             "address": "0xd183f2bbf8b28d9fec8367cb06fe72b88778c86b",
  //             "tag": "",
  //             "value": "17084871.813554615807897732872276",
  //             "is_contract": 0,
  //             "balance": "3569085413.326249898523231768",
  //             "percent": "0.999480634184567643",
  //             "NFT_list": [
  //                 {
  //                     "value": "17084871.813554615807897732872276",
  //                     "NFT_id": "67552",
  //                     "amount": "3569085413.326249898523231768",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.999480634184567643"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0xe8865eb232852f09a7ad6e305f9b541a654d1117",
  //             "tag": "",
  //             "value": "6479.514081482476145519650691",
  //             "is_contract": 0,
  //             "balance": "1353591.61286265698315135",
  //             "percent": "0.000379057502686673",
  //             "NFT_list": [
  //                 {
  //                     "value": "6479.514081482476145519650691",
  //                     "NFT_id": "172759",
  //                     "amount": "1353591.61286265698315135",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000379057502686673"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0xdbe159fbeb3d0e576ff259a707d29703aa01d357",
  //             "tag": "",
  //             "value": "66.962821418566352130292263",
  //             "is_contract": 0,
  //             "balance": "223317.236470275527085947",
  //             "percent": "0.000062537380668523",
  //             "NFT_list": [
  //                 {
  //                     "value": "66.962821418566352130292263",
  //                     "NFT_id": "1580676",
  //                     "amount": "223317.236470275527085947",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000062537380668523"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x9af789bce7c37c8a0a03d6e5955ddcc722774d84",
  //             "tag": "",
  //             "value": "83.308139094639715231741672",
  //             "is_contract": 0,
  //             "balance": "104211.527169971793153669",
  //             "percent": "0.000029183219565517",
  //             "NFT_list": [
  //                 {
  //                     "value": "83.308139094639715231741672",
  //                     "NFT_id": "159679",
  //                     "amount": "104211.527169971793153669",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000029183219565517"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x12c58a873124137a8f7bb128d2bf62eb265bf1b8",
  //             "tag": "",
  //             "value": "190.29544720412043381008553",
  //             "is_contract": 0,
  //             "balance": "44364.736927445354922589",
  //             "percent": "0.000012423825788565",
  //             "NFT_list": [
  //                 {
  //                     "value": "190.29544720412043381008553",
  //                     "NFT_id": "123654",
  //                     "amount": "44364.736927445354922589",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000012423825788565"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x6e45c848f596c02654ccce00f1472f2208d4a557",
  //             "tag": "",
  //             "value": "48.573217652127242710554089",
  //             "is_contract": 0,
  //             "balance": "37400.75629016220378928",
  //             "percent": "0.000010473644445801",
  //             "NFT_list": [
  //                 {
  //                     "value": "48.573217652127242710554089",
  //                     "NFT_id": "1614787",
  //                     "amount": "37400.75629016220378928",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000010473644445801"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x2fdce722838c3d518ca55a8b7741cf909721c998",
  //             "tag": "",
  //             "value": "5.553990131457979862097201",
  //             "is_contract": 0,
  //             "balance": "18522.244153775871851689",
  //             "percent": "0.000005186937881681",
  //             "NFT_list": [
  //                 {
  //                     "value": "5.553990131457979862097201",
  //                     "NFT_id": "1539470",
  //                     "amount": "18522.244153775871851689",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000005186937881681"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x374e72ca98f382beed593d3c875bd233992c983d",
  //             "tag": "",
  //             "value": "19.992100019062569812619653",
  //             "is_contract": 0,
  //             "balance": "15393.661294924740659379",
  //             "percent": "0.000004310814836772",
  //             "NFT_list": [
  //                 {
  //                     "value": "19.992100019062569812619653",
  //                     "NFT_id": "1318170",
  //                     "amount": "15393.661294924740659379",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000004310814836772"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0xb1aa917ed5045f0beadbd1798394a9a33cbaaf23",
  //             "tag": "",
  //             "value": "4.546946431601772055947107",
  //             "is_contract": 0,
  //             "balance": "15163.810155737431025396",
  //             "percent": "0.000004246447713053",
  //             "NFT_list": [
  //                 {
  //                     "value": "4.546946431601772055947107",
  //                     "NFT_id": "1616590",
  //                     "amount": "15163.810155737431025396",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000004246447713053"
  //                 }
  //             ],
  //             "is_locked": 0
  //         },
  //         {
  //             "address": "0x2678e0d100abe99e4d00f8f1082c958845d4a387",
  //             "tag": "",
  //             "value": "507.476905683315688080056606",
  //             "is_contract": 0,
  //             "balance": "11339.719559106349383673",
  //             "percent": "0.000003175555859238",
  //             "NFT_list": [
  //                 {
  //                     "value": "507.476905683315688080056606",
  //                     "NFT_id": "791396",
  //                     "amount": "11339.719559106349383673",
  //                     "in_effect": "1",
  //                     "NFT_percentage": "0.000003175555859238"
  //                 }
  //             ],
  //             "is_locked": 0
  //         }
  //     ],
  //     "lp_total_supply": "3570940037.5106916",
  //     "owner_address": "0xf68a4b64162906eff0ff6ae34e2bb1cd42fef62d",
  //     "owner_balance": "1500.006000756763557875",
  //     "owner_change_balance": "0",
  //     "owner_percent": "0.000000",
  //     "personal_slippage_modifiable": "0",
  //     "selfdestruct": "0",
  //     "sell_tax": "0",
  //     "slippage_modifiable": "0",
  //     "token_name": "Tether USD",
  //     "token_symbol": "USDT",
  //     "total_supply": "5184994301.618545272902185873",
  //     "trading_cooldown": "0",
  //     "transfer_pausable": "0",
  //     "trust_list": "1"
  // }

  analysisResult.push({
    label: "Token Name",
    value: data.token_name,
  });
  analysisResult.push({
    label: "Token Symbol",
    value: data.token_symbol,
  });
    analysisResult.push({
      label: "Total Supply",
      value:Number( data.total_supply).toFixed(8),
    });
    analysisResult.push({
      label: "Owner Balance",
      value: Number(data.owner_balance).toFixed(8),
    });
    analysisResult.push({
      label: "Owner Percent",
      value: data.owner_percent,
    });
    analysisResult.push({
      label: "Holder Count",
      value: data.holder_count,
    });
    analysisResult.push({
      label: "Lp Holder Count",
      value: data.lp_holder_count,
    });
    analysisResult.push({
      label: "Listed in DEX",
      value: data.is_in_dex ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Mintable",
      value: data.is_mintable ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Taxable on Buy",
      value: data.buy_tax> 0 ? data.buy_tax : "No",
    });
    analysisResult.push({
      label: "Taxable on Sell",
      value: data.sell_tax> 0 ? data.sell_tax : "No",
    });

    analysisResult.push({
      label: "Blacklist",
      value: data.blacklist === "1" ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Whitelist", 
      value: data.whitelist === "1" ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Anti Whale",
      value: data.anti_whale === "1" ? "Yes" : "No", 
    });
    analysisResult.push({
      label: "Trading Cooldown",
      value: data.trading_cooldown === "1" ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Transfer Pausable",
      value: data.transfer_pausable === "1" ? "Yes" : "No",
    });
    analysisResult.push({
      label: "Trust List",
      value: data.trust_list === "1" ? "Yes" : "No",
    });

    
    
    
    
    
  
    

    setAnalysisData(analysisResult);

  };

  return (
    <section className={clsx(classes.wrapper, "container")}>
      <Heading xl4 regular className={classes.heading}>
        Teme UNS Analysis Dashboard
      </Heading>
      <TradingChart
        PERIODS={PERIODS}
        handleAnalyse={handleAnalyse}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        showPeriodDropdown={showPeriodDropdown}
        setShowPeriodDropdown={setShowPeriodDropdown}
        contactAddress={contactAddress}
        setContactAddress={setContactAddress}
        showCurrencyDropdown={showCurrencyDropdown}
        setShowCurrencyDropdown={setShowCurrencyDropdown}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
      />
      <Details data={analysisData} />
      <div className={classes.container}>
        <FilteringSection />
        <AiAnalysis />
      </div>
    </section>
  );
};

export default AnalyticsPage;
